module.exports = __webpack_public_path__ + "static/media/risk-exist-comorbidity.d772b92f.svg";